import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { LayoutContext } from 'contexts/LayoutContext';
import { View } from 'dripsy';

import { useCallback, useContext, useEffect, useState } from 'react';
import { AccountManagementStackRoutes, AccountManagementStackScreenProps } from '../../account.navigator';
import { ModalContainerView } from '../../components/ModalContainerView';
import { CancelCardMain } from './CancelCardMain';
import { CancelCardConfirm } from './CancelCardConfirm';
import { CancelCardPlaced } from './CancelCardPlaced';

import { CancelCardStackParamList, CancelCardStackRoutes } from './type';

const CancelCardStack = createNativeStackNavigator<CancelCardStackParamList>();

export const CancelCardNavigator: React.FC<AccountManagementStackScreenProps<AccountManagementStackRoutes.CancelCard>> = ({ route }) => {
  const { account, tab, record, func, refresh, onChangeView } = route.params;
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const layout = useContext(LayoutContext);

  useEffect(() => {
    if (!layout.isMobile) return;
    setDimensions(layout.dimensions);
  }, [layout.dimensions]);

  const onLayout = useCallback((event) => {
    const { width, height } = event.nativeEvent.layout;
    setDimensions({ width, height });
  }, []);

  const [data, setData] = useState(undefined);
  const onData = (data: any) => {
    setData(data);
  };

  const [returnData, setReturnData] = useState(undefined);
  const onReturnData = (data: any) => {
    setReturnData(data);
  };

  return (
    <ModalContainerView dimensions={dimensions}>
      <View sx={{ height: dimensions.height, width: dimensions.width }} onLayout={onLayout}>
        <CancelCardStack.Navigator
          initialRouteName={CancelCardStackRoutes.Main}
          screenOptions={{
            presentation: layout.isMobile ? 'modal' : 'transparentModal',
            headerShown: false
          }}>
          <CancelCardStack.Screen
            name={CancelCardStackRoutes.Main}
            component={CancelCardMain}
            initialParams={{ onLayout, onData, account, tab, record, func, onReturnData, refresh }}
            options={{ headerShown: false }}
          />
          <CancelCardStack.Screen
            name={CancelCardStackRoutes.Confirm}
            component={CancelCardConfirm}
            initialParams={{ onLayout, account, tab, record, func, data, onReturnData, refresh, onChangeView }}
            options={{
              presentation: 'transparentModal',
              headerShown: false,
              contentStyle: {
                backgroundColor: 'transparent'
              }
            }}
          />
          <CancelCardStack.Screen
            name={CancelCardStackRoutes.Placed}
            component={CancelCardPlaced}
            initialParams={{ onLayout, account, tab, record, data, returnData, refresh }}
            options={{ presentation: layout.isMobile ? 'modal' : 'transparentModal', headerShown: false }}
          />
        </CancelCardStack.Navigator>
      </View>
    </ModalContainerView>
  );
};
